import SearchIcon from "@assets/images/magnifier.svg";
import SearchThinIcon from "@assets/images/search-thin.svg";
import { Button } from "@material-ui/core";
import ModalResultRoute from "@saleor/changeOrderDomestic/components/ModalResultRoute";
import MyTypography from "@saleor/components/MyTypography";
import { SingleSelectField } from "@saleor/components/SingleSelectField";
import SingleTextField from "@saleor/components/SingleTextField2";
import { useCallApiSapRouteMutation } from "@saleor/graphql";
import { makeStyles } from "@saleor/macaw-ui";
import classNames from "classnames";
import React, { useEffect, useState } from "react";
import SVG from "react-inlinesvg";
import { useIntl } from "react-intl";

interface SearchRouteProps {
  route: string;
  setRoute: (value: string, itemId?: string) => void;
  contractNo: string;
  showErrorRoute?: boolean;
  disabled?: boolean;
  itemId?: string;
  placehoder?: string;
  buttonWithNonContained?: boolean;
  btnClsNames?: string;
}

const useStyles = makeStyles(
  theme => ({
    root: {
      display: "flex",
      alignItems: "center",
      gap: 10,
      "& .MuiFormControl-root": {
        height: 38
      }
    },
    routerBtn: {
      height: 38
    },
    errorText: {
      color: theme.palette.error.light
    },
    selectType: {
      width: 160
    },
    fieldRoute: {
      width: "100%"
    },
    routerThinBtn: {
      minWidth: "auto"
      // padding: "0px"
    }
  }),
  { name: "SearchRoute" }
);

const SearchRoute: React.FC<SearchRouteProps> = props => {
  const {
    route,
    setRoute,
    contractNo,
    showErrorRoute,
    disabled,
    itemId,
    placehoder,
    buttonWithNonContained,
    btnClsNames
  } = props;
  const classes = useStyles();
  const [typeSelect, setTypeSelect] = useState<string>("Name");
  const [textRoute, setTextRoute] = useState<string>(route);
  const [errorRoute, setErrorRoute] = useState<boolean>(false);
  const [listRoute, setListRoute] = useState<any[]>([]);
  const [openResultRoute, setOpenResultRouter] = useState<boolean>(false);
  const intl = useIntl();

  const handleChangeType = value => {
    setTypeSelect(value.target.value);
  };

  const handelChangeTextRoute = value => {
    setTextRoute(value.target.value);
  };

  useEffect(() => {
    setRoute(textRoute, itemId);
    setErrorRoute(false);
  }, [textRoute]);

  const typeChoices = [
    { label: "Name", value: "Name" },
    { label: "Code", value: "Code" }
  ];

  const [callApiRoute, { loading: loadingRoute }] = useCallApiSapRouteMutation({
    onCompleted: data => {
      const listResponse = data?.callApiSapRoute?.response?.routeList || [];
      if (listResponse.length) {
        setListRoute(listResponse);
        setOpenResultRouter(true);
      } else {
        setListRoute([]);
        setOpenResultRouter(true);
      }
      setErrorRoute(false);
    }
  });

  const handleOpenResult = () => {
    if (textRoute) {
      callApiRoute({
        variables: {
          maxRecords: 100,
          route: typeSelect === "Code" ? textRoute : "",
          routeDescription: typeSelect === "Name" ? textRoute : "",
          piMessageId: contractNo
        }
      });
    } else {
      setErrorRoute(true);
    }
  };

  const handleChooseRoute = value => {
    setTextRoute(`${value.route} - ${value.routeDescription}`);
    setOpenResultRouter(false);
    setErrorRoute(false);
  };

  return (
    <>
      <div className={classes.root}>
        <SingleSelectField
          choices={typeChoices}
          onChange={handleChangeType}
          value={typeSelect}
          className={classes.selectType}
          disabled={disabled}
          id={`type-route-select-${itemId}`}
        />
        <div className={classes.fieldRoute}>
          <SingleTextField
            onChange={handelChangeTextRoute}
            value={textRoute}
            clearAble
            placeholder={placehoder || "กรุณาระบุข้อมูลและกดค้นหา"}
            disabled={disabled}
            id={`text-route-${itemId}`}
          />
          {errorRoute && showErrorRoute ? (
            <MyTypography variant={"caption"} className={classes.errorText}>
              {intl.formatMessage({ defaultMessage: "กรุณาระบุคำค้นหา" })}
            </MyTypography>
          ) : (
            ""
          )}
        </div>
        {buttonWithNonContained ? (
          <>
            <Button
              variant={"text"}
              className={classNames(classes.routerThinBtn)}
              onClick={handleOpenResult}
              disabled={loadingRoute || disabled}
              id={`search-route-button-${itemId}`}
            >
              <SVG src={SearchThinIcon} />
            </Button>
          </>
        ) : (
          <Button
            variant={"contained"}
            className={classNames("defaultB", classes.routerBtn, btnClsNames)}
            onClick={handleOpenResult}
            disabled={loadingRoute || disabled}
            id={`search-route-button-${itemId}`}
          >
            <SVG src={SearchIcon} />
          </Button>
        )}
      </div>
      <ModalResultRoute
        listResult={listRoute}
        open={openResultRoute}
        onClose={() => setOpenResultRouter(false)}
        onChoose={handleChooseRoute}
      />
    </>
  );
};

export default SearchRoute;
